import { RouteType } from "../../router/enums";
import { MainRouteWithFormValidator, Route } from "../../router/types";

export function isMainRouteWithFormValidator(
  route: Route
): route is MainRouteWithFormValidator {
  return (
    "type" in route &&
    route.type === RouteType.MAIN_ROUTE &&
    "formValidatedSelector" in route
  );
}
